const siteBody = document.querySelector('body');
const siteHeader = document.getElementById('masthead');
const mainMenu = document.querySelector('#main-menu-container');
const megaMenu = document.querySelector('#mega-menu-container');
const searchWrapper = document.querySelector('.site-search-wrapper');
const searchInput = searchWrapper.querySelector('.main-search-input');

let dropdownBtn, dropdown
const submenu_classes = [
    '!flex',
    '!opacity-100',
    '!pointer-events-auto',
    'lg:!px-0',
];

document.addEventListener('click', function (e) {
    if (e.target.closest('.main-menu-toggle-btn') || e.target.closest('.mega-menu-toggle-btn') || e.target.classList.contains('menu-item-link')) {
        closeSearch();

        let menuBtn, menu, lines;

        if (e.target.closest('.main-menu-toggle-btn')) {
            siteHeader.classList.toggle('mobile-menu-open');
            mainMenu.classList.toggle('!block');

            menuBtn = document.querySelector('.main-menu-toggle-btn');
            menu = document.getElementById('main-menu');
            lines = menuBtn.querySelectorAll('span');

            lines[0].classList.toggle('rotate-45');
            lines[0].classList.toggle('translate-y-[3px]')
            lines[1].classList.toggle('hidden')
            lines[2].classList.toggle('-rotate-45')
            lines[2].classList.toggle('-translate-y-[2px]')
            menuBtn.classList.toggle('!gap-[3px]')
            menu.classList.toggle('!block')
            menu.classList.toggle('md:!flex')
        }
        else if (e.target.closest('.mega-menu-toggle-btn')) {
            toggleMegaMenu();
        }
            
        
        // siteHeader.classList.toggle('!fixed')

    }

    // if clicking outside of dropdown menu and dropdown menu is open then close it
    if (dropdown && e.target !== dropdown && !dropdown.contains(e.target)) {
        dropdownBtn.classList.remove('pointer-events-none')
        dropdown.classList.remove('!block')
    }

    if (e.target.classList.contains('dropdown-btn')) {
        dropdownBtn = e.target
        mainMenu.classList.remove('!flex')
        dropdown = e.target.closest('.dropdown-btn').nextElementSibling
        if (dropdown.classList.contains('!block')) {
            dropdown.classList.remove('!block')
        } else {
            dropdownBtn.classList.add('pointer-events-none')
            dropdown.classList.add('!block')
        }
    }

    if (e.target.classList.contains('sub-menu-toggle-button')) {
        const parent = e.target.closest('.menu-item-has-children');
        const submenu = parent.querySelector('.sub-menu');
        const icon = e.target.querySelector('ion-icon');

        if (submenu.classList.contains('!flex')) {
            submenu.classList.remove(...submenu_classes);
            icon.setAttribute('name', 'chevron-down');
        } else {
            submenu.classList.add(...submenu_classes);
            icon.setAttribute('name', 'chevron-up');
        }
    }

    // Search toggle

    if (e.target.classList.contains('search-toggle')) {
        if (siteHeader.classList.contains('mega-menu-open')) {
            toggleMegaMenu();
        }

        searchWrapper.classList.toggle('!block')
        mainMenu.classList.remove('!flex')

        searchInput.focus()
    }

    if (e.target.classList.contains('search-overlay') || e.target.classList.contains('close-search')) {
        closeSearch()
    }
})

function toggleMegaMenu() {
    closeSearch();
     
    siteHeader.classList.toggle('mega-menu-open');

    megaMenu.classList.toggle('!visible');
    megaMenu.classList.toggle('!opacity-100');

    menuBtn = document.querySelector('.mega-menu-toggle-btn');
    menu = document.getElementById('mega-menu');
    lines = menuBtn.querySelectorAll('span');

    lines[0].classList.toggle('rotate-45');
    lines[0].classList.toggle('translate-y-[3px]')
    lines[1].classList.toggle('hidden')
    lines[2].classList.toggle('-rotate-45')
    lines[2].classList.toggle('-translate-y-[2px]')
    menuBtn.classList.toggle('!gap-[3px]')
    menu.classList.toggle('!block')
    menu.classList.toggle('md:!flex')
}

// remove submenu_classes from submenu when window is resized, only once
const submenus = document.querySelectorAll('.sub-menu')
let resized = false
window.addEventListener('resize', function () {
    if (window.innerWidth > 1024) {
        if (resized) return
        submenus.forEach((submenu) => submenu.classList.remove(...submenu_classes))
        resized = true
    } else {
        if (!resized) return
        submenus.forEach((submenu) => submenu.classList.remove(...submenu_classes))
        resized = false
    }
})

function closeSearch() {
    searchInput.value = ''
    searchWrapper.classList.remove('!block')
    return
}

document.addEventListener('keyup', function (e) {
    if (e.target.classList.contains('main-search-input')) {
        if (e.key === 'Escape') {
            closeSearch()
        }
    }
})
